import { useState, useEffect } from "react";
import { createUseStyles } from "react-jss";

import { actionEffectService } from "services";
import { ActionEffectCommon, ActionEffectDto, ActionEffectRequestDto } from "dtos/shard/action-effect.dto";
import { UserDto } from "dtos/user.dto";

import widgets from "styles/widgets";
import { useResources } from "hooks/resources.hook";
import { useEditorActions } from "hooks/editor-actions.hook";
import { useEditorPreview } from "hooks/editor-preview.hook";
import EditorControls from "../editor-controls";

const styles = createUseStyles({
    container: {
        width: "100%",
    },
});

export default function ActionEffectEditor(props: {
    user?: UserDto, // Optional dto of the user.
    actionEffect?: Partial<ActionEffectDto>,
    preview?: Partial<ActionEffectDto>,
    onPreviewUpdate?: (previewDto: Partial<ActionEffectDto>) => void,
    onClose?: () => void,
    onSave?:(actionEffect: ActionEffectDto) => void,
}): JSX.Element
{
    // Dtos:
    const freshCommon: ActionEffectCommon = {
        name: props.actionEffect?.name ?? "",
    };
    const freshRequestDto: ActionEffectRequestDto = {
        id: props.actionEffect?.id,
        ...freshCommon,
    };
    const freshPreviewDto: Partial<ActionEffectDto> = props.preview ? structuredClone(props.preview) : props.actionEffect ? structuredClone(props.actionEffect) : {
        id: undefined,
        ...freshCommon,
    };

    // Hooks:
    const resources = useResources(props.user);
    const [previewDto, requestDto, previewUpdate, setRequestDto] = useEditorPreview(freshPreviewDto, freshRequestDto, props.onPreviewUpdate);
    const [onTextChange, onNumberChange, onRteChange, onCheckboxChange, onPopup] = useEditorActions(props.user, "actionEffect", resources, requestDto, previewDto, setRequestDto, props.onPreviewUpdate);

    // Effects:
    useEffect(() => {
        setRequestDto(freshRequestDto);
    }, [props.actionEffect]);

    // Styles:
    const widgetClasses = widgets();
    const classes = styles();

    // ActionEffects:
    const reset = () => {
        setRequestDto(freshRequestDto);
        if (props.onPreviewUpdate) {
            props.onPreviewUpdate(props.actionEffect ?? previewDto);
        }
    };
    
    // Return Component:
    return (
        <div className={`${widgetClasses.form} ${classes.container}`}>
            <div className={`${widgetClasses.row}`}>
                <label>Name</label>
                <input id="name" type="text" value={requestDto.name ?? ""} onChange={onTextChange} />
            </div>

            <hr/>
            <EditorControls
                editorName="actionEffect"
                service={actionEffectService}
                subject={props.actionEffect}
                subjectName={props.actionEffect?.name ?? ""}
                requestDto={requestDto}
                onSave={props.onSave}
                onReset={reset}
                onClose={props.onClose}
            />
            <hr/>
        </div>
    );
}